import * as React from "react";
import * as _ from "lodash";
import TextInput from "../TextInput";
import {PrescriptionItemFitnessGuideline} from "../../models/IFitnessPrescription";

interface FitnessPlanGuidelinesItemEditorProps {
    item: PrescriptionItemFitnessGuideline,
    onDataChange: (update: PrescriptionItemFitnessGuideline) => void,
    getGuidelineMeta: () => any
}

export default class FitnessPlanGuidelinesItemEditor extends React.Component<FitnessPlanGuidelinesItemEditorProps> {

    onGuidelinesChange = (event: any) => {
        this.props.onDataChange(event.target.value || "");
    }

    render () {
        return (
            <div className={"fitness-guideline-input-container"}>
                <TextInput name="fitness-plan-guideline" value={this.props.item || ""} onChange={this.onGuidelinesChange} placeholder={"Guidelines"}/>
            </div>
        )
    }
}